<!-- ══════════════════════════════════════════════════════════════════════ -->
<!-- SNAPSHOT REPORT — Report For                                         -->
<!-- ══════════════════════════════════════════════════════════════════════ -->
@if (isSnapShotReport) {
  <div class="filter-section" data-cy="financial-snapshot-filters-snapshot">
    <div class="section-title" data-cy="financial-snapshot-filters-report-for-title">Report For</div>
    <mat-radio-group aria-label="Report For" data-cy="financial-snapshot-filters-report-for-group">
      <!-- Provider -->
      <div class="radio-row" data-cy="financial-snapshot-filters-provider-radio-container">
        <mat-radio-button value="true" (change)="radioChangeReportFor($event)" data-cy="financial-snapshot-filters-provider-radio">
          Provider
        </mat-radio-button>
        @if (isReportForProvide) {
          <div class="radio-field" data-cy="financial-snapshot-filters-provider-select-wrapper">
            <mat-form-field floatLabel="auto" style="width: 100%" data-cy="financial-snapshot-filters-provider-form-field">
              <mat-select [formControl]="doctor" required data-cy="financial-snapshot-filters-provider-select">
                @for (doctor of staticDataService.currentLocationDoctors; track doctor) {
                  <mat-option (onSelectionChange)="onDoctorSelect(doctor, $event)"
                    [value]="doctor"
                    [attr.data-cy]="'financial-snapshot-filters-provider-option-' + doctor.dataContact.LastName.toLowerCase()">
                    {{doctor.dataContact.FirstName}} {{doctor.dataContact.LastName}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
      </div>
      <!-- Practice -->
      <div class="radio-row" data-cy="financial-snapshot-filters-practice-radio-container">
        <mat-radio-button value="false" [checked]="true" (change)="radioChangeReportFor($event)" data-cy="financial-snapshot-filters-practice-radio">
          Practice
        </mat-radio-button>
        @if (!isReportForProvide) {
          <div class="radio-field" data-cy="financial-snapshot-filters-practice-dropdown-wrapper">
            <app-tdo-dropdown [dataSource]="clientList"
              dataSourceDisplayKey="Name"
              [isObjectValue]="true"
              [value]="selectedClient"
              (selectionChange)="onChangeClient($event)"
              data-cy="financial-snapshot-filters-practice-dropdown">
            </app-tdo-dropdown>
          </div>
        }
      </div>
    </mat-radio-group>
  </div>
}

<!-- ══════════════════════════════════════════════════════════════════════ -->
<!-- NON-SNAPSHOT REPORT — Report For                                     -->
<!-- ══════════════════════════════════════════════════════════════════════ -->
@if (!isSnapShotReport) {
  <div class="filter-section" data-cy="financial-snapshot-filters-nonsnapshot">
    <div class="section-title" data-cy="financial-snapshot-filters-nonsnapshot-report-for-title">Report For</div>
    <!-- Provider -->
    <div class="field-row" data-cy="financial-snapshot-filters-nonsnapshot-provider-dropdown-container">
      <span class="field-label" data-cy="financial-snapshot-filters-nonsnapshot-provider-text">Provider</span>
      <div class="field-control" data-cy="financial-snapshot-filters-nonsnapshot-provider-dropdown-wrapper">
        <tdo-dropdown-v2 [isMultiSelect]="true"
          [isIncludeAll]="true"
          [isPreventMouseEventPropagation]="true"
          [datasource]="staticDataService.currentLocationDoctors"
          [displayPredicate]="doctorPredicate"
          [value]="selectedProviders"
          (selectionChange)="onDoctorsSelected($event)"
          (closed)="onDoctorsSelected($event)"
          data-cy="financial-snapshot-filters-nonsnapshot-provider-dropdown">
        </tdo-dropdown-v2>
      </div>
    </div>
    <!-- Snapshot Type -->
    <div class="field-row" data-cy="financial-snapshot-filters-nonsnapshot-snapshot-dropdown-container">
      <span class="field-label" data-cy="financial-snapshot-filters-nonsnapshot-snapshot-text">Snapshot</span>
      <div class="field-control" data-cy="financial-snapshot-filters-nonsnapshot-snapshot-dropdown-wrapper">
        <app-tdo-dropdown [dataSource]="filterRSFSnapshotTypeEnums"
          dataSourceDisplayKey="ItemDisplayValue"
          [isObjectValue]="true"
          [value]="selectedSnapshotType"
          (selectionChange)="onChangeSnapshotType($event)"
          data-cy="financial-snapshot-filters-nonsnapshot-snapshot-dropdown">
        </app-tdo-dropdown>
      </div>
    </div>
  </div>
}

<!-- ══════════════════════════════════════════════════════════════════════ -->
<!-- Date Range                                                           -->
<!-- ══════════════════════════════════════════════════════════════════════ -->
@if (!isDailySnapShot) {
  <div class="filter-section" data-cy="financial-snapshot-filters-date-range">
    <div class="section-title" data-cy="financial-snapshot-filters-date-range-title">Date Range</div>
    <div class="field-row" data-cy="financial-snapshot-filters-date-range-dropdown-container">
      <div class="field-control" data-cy="financial-snapshot-filters-date-range-dropdown-wrapper">
        <app-tdo-dropdown placeholder="Select Date Range"
          [dataSource]="filterDateRangesEnums"
          dataSourceDisplayKey="ItemDisplayValue"
          [isObjectValue]="true"
          [value]="selectedDateRanges"
          (selectionChange)="onChangeDateRanges($event)"
          data-cy="financial-snapshot-filters-date-range-dropdown">
        </app-tdo-dropdown>
      </div>
    </div>
    <div class="field-row" data-cy="financial-snapshot-filters-date-picker-container">
      <div class="field-control">
        <mat-form-field appearance="fill" class="date-picker-field" data-cy="financial-snapshot-filters-date-picker-form-field">
          <mat-label data-cy="financial-snapshot-filters-date-picker-label">Enter a date range</mat-label>
          <mat-date-range-input [rangePicker]="rangePicker" data-cy="financial-snapshot-filters-date-picker-input">
            <input matStartDate placeholder="Start date" [(ngModel)]="startDate" disabled="false" data-cy="financial-snapshot-filters-date-picker-start">
            <input matEndDate placeholder="End date" [(ngModel)]="endDate" disabled="false" data-cy="financial-snapshot-filters-date-picker-end">
          </mat-date-range-input>
          <mat-hint data-cy="financial-snapshot-filters-date-picker-hint">MM/DD/YYYY – MM/DD/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="rangePicker" data-cy="financial-snapshot-filters-date-picker-toggle"></mat-datepicker-toggle>
          <mat-date-range-picker #rangePicker data-cy="financial-snapshot-filters-date-range-picker">
            <mat-date-range-picker-actions data-cy="financial-snapshot-filters-date-picker-actions">
              <button mat-button matDateRangePickerCancel data-cy="financial-snapshot-filters-date-picker-cancel">Cancel</button>
              <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()" data-cy="financial-snapshot-filters-date-picker-apply">Apply</button>
            </mat-date-range-picker-actions>
          </mat-date-range-picker>
        </mat-form-field>
      </div>
    </div>
  </div>
}

<!-- ══════════════════════════════════════════════════════════════════════ -->
<!-- Order By                                                             -->
<!-- ══════════════════════════════════════════════════════════════════════ -->
<div class="filter-section" data-cy="financial-snapshot-filters-order-by">
  <div class="section-title" data-cy="financial-snapshot-filters-order-by-title">Order By</div>

  <div class="order-row" data-cy="financial-snapshot-filters-order-by-row">
    <mat-radio-group aria-label="Order By" data-cy="financial-snapshot-filters-order-by-group">
      <mat-radio-button value="true" [checked]="true" (change)="radioChange($event)" data-cy="financial-snapshot-filters-order-asc">Asc</mat-radio-button>
      <mat-radio-button value="false" (change)="radioChange($event)" data-cy="financial-snapshot-filters-order-desc">Desc</mat-radio-button>
    </mat-radio-group>

    @if (!isSnapShotReport) {
      <div class="order-field" data-cy="financial-snapshot-filters-order-nonsnapshot-container">
        <app-tdo-dropdown [dataSource]="orderByOption"
          dataSourceDisplayKey="viewValue"
          [isObjectValue]="true"
          [value]="selectedOrderByOption"
          (selectionChange)="onChangeOrderByOption($event)"
          data-cy="financial-snapshot-filters-order-nonsnapshot-dropdown">
        </app-tdo-dropdown>
      </div>
    }

    @if (isSnapShotReport) {
      <div class="order-field" data-cy="financial-snapshot-filters-order-snapshot-container">
        <app-tdo-dropdown [dataSource]="orderByOptionDaily"
          dataSourceDisplayKey="viewValue"
          [isObjectValue]="true"
          [value]="selectedSnapShotOrderBy"
          (selectionChange)="onChangeOrderByOptionDaily($event)"
          data-cy="financial-snapshot-filters-order-snapshot-dropdown">
        </app-tdo-dropdown>
      </div>
    }
  </div>
</div>

<!-- ══════════════════════════════════════════════════════════════════════ -->
<!-- Miscellaneous (snapshot only)                                        -->
<!-- ══════════════════════════════════════════════════════════════════════ -->
@if (isSnapShotReport) {
  <div class="filter-section" data-cy="financial-snapshot-filters-misc">
    <div class="section-title" data-cy="financial-snapshot-filters-misc-title">Miscellaneous</div>
    <div class="checkbox-group" data-cy="financial-snapshot-filters-checkbox-group">
      <mat-checkbox id="isInteractiveReport" checked="true" [formControl]="checkboxSnapShotReport" (change)="toggle($event)" data-cy="financial-snapshot-filters-interactive-checkbox">
        Show Interactive Report
      </mat-checkbox>
      <mat-checkbox id="showInactive" [formControl]="checkboxShowActiveDoctors" (change)="showInactiveDoc($event)" data-cy="financial-snapshot-filters-inactive-checkbox">
        Show Inactive Doctors
      </mat-checkbox>
    </div>
  </div>
}
